<template>
  <div class="main">
    <img class="logo" src="../../assets/icon_ccxmt.png" />
    <div class="title">创建文明城市综合指挥系统</div>
    <div class="loginDialog">
      <div class="loginType">用户登录</div>
      <!-- <div class="switchType" @click="switchType()">{{ switchTypeStr }}</div> -->
      <div class="border">
        <img class="borderIcon" src="../../assets/icon_people.png" />
        <input
          v-model="account"
          class="borderInput"
          placeholder="请输入单位名称"
          maxlength="20"
        />
      </div>
      <div class="border" style="margin-top: 30px">
        <img class="borderIcon" src="../../assets/icon_block.png" />
        <input
          v-model="password"
          class="borderInput"
          type="password"
          placeholder="请输入密码"
          maxlength="20"
          @keyup.enter="login"
        />
      </div>
      <div class="forgetPwd" @click="forget">忘记密码？</div>
      <div class="loginBtn" @click="login">登录</div>
    </div>
    <a-modal
      v-model="passVisible"
      title="修改密码"
      @ok="forget"
      :maskClosable="false"
    >
      <p>检测到您的密码强度较弱,建议您修改密码为8-12位字母加数字组合形式</p>
    </a-modal>
  </div>
</template>
<script>
import constants from '../../constants.js';
import storeUtil from '../../utils/storeUtil.js';
import server from '../../interface/user.js';
import gradeSysServer from '../../interface/gradeSys.js';

export default {
  name: '',
  data() {
    return {
      userType: constants.role_unit,
      loginTypeStr: '责任单位登录',
      switchTypeStr: '选择文明办账号登录？',
      account: '',
      password: '',
      passVisible: false,
      isShow: false,
    };
  },
  mounted() {},
  methods: {
    emitEmpty() {
      this.$refs.userNameInput.focus();
      this.userName = '';
    },
    switchType() {
      if (this.userType == constants.role_unit) {
        this.userType = constants.role_sysAdmin;
        this.loginTypeStr = '文明办登录';
        this.switchTypeStr = '点击选择责任单位账号登录';
      } else {
        this.userType = constants.role_unit;
        this.loginTypeStr = '责任单位登录';
        this.switchTypeStr = '点击选择文明办账号登录';
      }
    },
    examPass() {
      this.isShow = true;
      let patnern = /(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,12}/;
      if (!patnern.test(this.password)) {
        this.passVisible = true;
        return;
      }
    },
    login() {
      if (!this.isShow) {
        this.examPass();
        return;
      }
      server
        .login({
          account: this.account,
          password: this.password,
        })
        .then((result) => {
          if (result.userInfo.status == constants.user_status_enable) {
            // if (
            //   this.userType == constants.role_unit &&
            //   result.userInfo.roleCode != constants.role_unit
            // ) {
            //   this.$message.error("请选择文明办登录");
            //   return;
            // }

            // if (
            //   this.userType == constants.role_sysAdmin &&
            //   result.userInfo.roleCode == constants.role_unit
            // ) {
            //   this.$message.error("请选择责任单位登录");
            //   return;
            // }

            storeUtil.setToken(result.token);
            storeUtil.setUserInfo(result.userInfo);

            this.getProjectList();
          } else if (
            result.userInfo.status == constants.user_status_unIdentity
          ) {
            this.$router.push({
              path: '/resetPwd',
              query: {
                login: 'login',
                /* account 参数为首次认证时使用 */
                account: this.account,
              },
            });
          } else if (
            result.userInfo.status == constants.user_status_forbidden
          ) {
            this.$message.error('该用户已被禁用，请联系管理员！', 2);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProjectList() {
      gradeSysServer
        .projectList()
        .then((result) => {
          console.log('result', result);
          this.projectList = [];
          if (result.length && result.length > 0) {
            if (storeUtil.getProject() == null) {
              let project = {
                id: result[0].id,
                name: result[0].name,
                year: result[0].year,
              };
              storeUtil.setProject(project);

              // 分角色，跳转不同页面
              if (
                storeUtil.getUserInfo().roleCode == constants.role_sysAdmin ||
                storeUtil.getUserInfo().roleCode ==
                  constants.role_primaryReview ||
                storeUtil.getUserInfo().roleCode == constants.role_finalReview|| storeUtil.getUserInfo().roleCode == constants.role_testReview
              ) {
                this.$router.push({
                  path: '/project/overview_admin',
                  query: {
                    projectID: project.id,
                  },
                });
              } else if (
                storeUtil.getUserInfo().roleCode == constants.role_unit
              ) {
                this.$router.push({
                  path: '/project/overview',
                  query: {
                    projectID: project.id,
                  },
                });
              }
            }
          } else {
            this.$message('No Data Found');
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    forget() {
      this.$router.push({
        path: '/resetPwd',
        query: {
          login: 'forgot',
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.main {
  background-image: url('../../assets/bg_login.png');
  background-size: 100% 100%;
  height: 100vh;
}

.logo {
  position: absolute;
  margin-left: 74px;
  margin-top: 70px;
  height: 70px;
}

.title {
  position: absolute;
  margin-top: 494px;
  margin-left: 150px;
  font-size: 48px;
  color: #ffffff;
  background-color: transparent;
  font-family: 'Source Han Sans CN';
  font-weight: 400;
}

.loginDialog {
  position: absolute;
  background-color: white;
  width: 422px;
  height: 576px;
  margin-top: 252px;
  right: 0vh;
  margin-right: 215px;
  border-radius: 15px;

  .loginType {
    cursor: pointer;
    margin-top: 85px;
    text-align: center;
    font-family: 'Source Han Sans CN';
    font-weight: 500;
    color: #2237bb;
    font-size: 25px;
  }

  .switchType {
    cursor: pointer;
    margin-top: 32px;
    text-align: center;
    font-family: 'Source Han Sans CN';
    font-weight: 400;
    color: #cccccc;
    font-size: 18px;
  }

  .border {
    position: relative;
    width: 320px;
    height: 59px;
    margin: 0 auto;
    border-radius: 4px;
    border-color: #cccccc;
    border-width: 2px;
    border-style: solid;
    margin-top: 46px;

    .borderIcon {
      position: absolute;
      width: 29px;
      height: 29px;
      top: 25%;
      margin-left: 15px;
    }

    .borderInput {
      position: absolute;
      outline: none;
      border: none;
      top: 25%;
      margin-left: 59px;
    }
  }

  .forgetPwd {
    margin-top: 13px;
    float: right;
    margin-right: 51px;
    font-family: "Source Han Sans CN";
    font-weight: 400;
    color: #cccccc;
    cursor: pointer;
    font-size: 18px;
  }

  .loginBtn {
    line-height: 60px;
    background-color: #5068fc;
    width: 320px;
    height: 60px;
    margin: 0 auto;
    margin-top: 76px;
    text-align: center;
    color: #ffffff;
    font-family: 'Source Han Sans CN';
    font-weight: 500;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
